const Paragraph = ({ children, className = '' }) => {
    return (
        <div className={`about-text ${className}`}>
            {children}
        </div>
    );
};

export default Paragraph;

